// extracted by mini-css-extract-plugin
export default {"root":"menu-item_root__CGeIN","selected":"menu-item_selected__Fztu0","divider":"menu-item_divider__o+IHs"};